<template>
  <v-container fluid>
    <v-layout justify-center wrap pt-3>
      <v-flex md12 style="text-align: right">
      </v-flex>
      <v-flex md12>
        <material-card color="orange" title="Attestation">
          <v-layout
              row
              wrap
              align-center>
              <v-flex md2 mr-4>
                  <v-select
                  v-model="searchField"
                  :items="searchColumns"
                  :menu-props="{ maxHeight: '400' }"
                  label="Select a field to Search"
                  attach
                  clearable
                  @change="clearResults"
                  />
              </v-flex>
            <v-flex
              v-if="searchField=='Customer_Id'"
              md4
              xl4>
              <v-autocomplete
                v-model="searchInput"
                :items="newAwsAcctExistingClient.customers"
                :disabled="newAwsAcctExistingClient.isCustomerFound"
                :item-text="(item) => `${item.Customer_Name} - ${item.Customer_Region}`"
                item-value="Customer_Id"
                label="Choose customer from this list of current DXC AWS customers"
                data-vv-validate-on="blur"
                cache-items
                flat
                hide-no-data
                attach
                light
                no-data-text="No results found"
                @change="onAccountSearch"
              />
            </v-flex>
            <v-flex
              v-else
              md4
              xl4>
              <v-layout>
                <v-text-field
                  v-model.trim="searchInput"
                  :label="`Enter the ${searchField} here`"
                  clearable
                >
                <template v-slot:append>
                  <v-btn
                    :disabled="!searchInput"
                    class="my-0"
                    small
                    @click="onAccountSearch"
                  >
                    <span>Search</span>
                  </v-btn>
                </template>
                </v-text-field>
                
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- <v-layout justify-center wrap>
            <v-flex xs12 sm3 md3 offset-md9>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout> -->
          <v-progress-linear
            v-if="loadingAccountData"
            color="orange"
            indeterminate/>
          <v-data-table
            :headers="attestationHeaders"
            :items="attestationAccounts"
            :pagination.sync="pagination"
          >
            <template
              v-if="attestationAccounts.length > 0"
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props" >
              <tr>
                <td>
                  <v-checkbox
                    v-if="props.item.Status === 'Not Submitted'"
                    v-model="accountCheckbox[props.index]"
                    color="orange"
                    @change="onAccountSelect(props.index)"
                    hide-details
                  />
                </td>
                <td>{{ props.item.Acct_ID }}</td>
                <td>{{ props.item.Acct_name }}</td>
                <td>{{ props.item.Customer_Name }}</td>
                <td>
                  <v-chip
                    :color="statusBgColor(props.item.Status)"
                    :text-color="statusTextColor(props.item.Status)">{{ props.item.Status }}</v-chip>
                </td>
                <td>{{ props.item.Created_At }}</td>
                <td>{{ props.item.Updated_At }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-btn v-if="showProceedButton" @click="proceedToNextStep">Proceed with the Attestation</v-btn>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    searchInput: '',
    searchField: 'Acct_ID',
    searchColumns: [
      { text: 'Account ID', value: 'Acct_ID' },
      { text: 'Account Name', value: 'Acct_Name' },
      { text: 'Customer Name', value: 'Customer_Id' }
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    showProceedButton: false,
    accountCheckbox: []
  }),
  computed: {
    ...mapState('user/attestation', ['attestationHeaders', 'attestationAccounts', 'loadingAccountData']),
    ...mapState('user/requestAws', ['newAwsAcctExistingClient'])
  },
  mounted () {
    let type = 'existing'
    this.$store.dispatch('user/requestAws/getCustomers', type)
  },
  methods: {
    onAccountSearch () {
      console.log('search starts....')
      this.showProceedButton = false
      this.accountCheckbox.forEach((value, index) => {
        this.accountCheckbox[index] = false
      })
      let searchData = {
        type: this.searchField,
        value: this.searchInput
      }
      this.$store.state['user/attestation'].nextPaginationKey = null
      this.$store.state['user/attestation'].accountDataFilters[this.searchField] = this.searchInput
      this.$store.dispatch('user/attestation/searchAccount')
    },
    onAccountSelect (cbIndex) {
      console.log('selected account', cbIndex, this.attestationAccounts[cbIndex])
      this.accountCheckbox.forEach((value, index) => {
        if (cbIndex !== index) {
          this.accountCheckbox[index] = false
        }
      })
      if (this.accountCheckbox[cbIndex]) {
        this.$store.commit('user/attestation/setSelectedAccountData', this.attestationAccounts[cbIndex])
        this.showProceedButton = true
      } else {
        this.showProceedButton = false
      }
    },
    proceedToNextStep () {
      this.$router.push({ path: '/attestation/new' })
    },
    statusBgColor (status) {
      switch (status) {
        case 'Not Submitted':
          return '#2ecc71'
        case 'Approved':
          return '#3498db'
        case 'Pending':
          return '#b7cdce'
        case 'Rejected':
          return '#FF5733'
        default:
          return '#fff'
      }
    },
    statusTextColor (status) {
      return status === 'Pending' ? '#000' : '#fff'
    },
    clearResults () {
      console.log('clearing results')
      this.$store.commit('user/attestation/clearAttestationAccountsData')
      this.searchInput = ''
    }
  },
  watch: {
    searchField (val) {
      this.$store.commit('user/attestation/clearFilters')
    }
  }
}
</script>

<style lang="scss" scoped>
.masterpayer-status-filter-checkbox {
  display: inline-block;
  flex: none;
}
</style>
